import React, { Fragment } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import {
  RootRoute,
  PrivateRoute,
  publicRoutes,
  //privateRoutes,
  //adminRoutes
} from './configs/appRoutes';
import { withTranslation } from 'react-i18next';
import useMetaTags from './handlers/useMetaTags';
import { TerminalGate } from './components/TerminalProvision/TerminalProvision';

function App() {
  useMetaTags();

  //  useEffect(() => {
  //
  //  }, []);

  return (
    <Fragment>
      <TerminalGate>
      <Router>
        <Switch>
          {publicRoutes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              component={route.component}
              render={route.render}
            />
          ))}
        </Switch>
      </Router>
      </TerminalGate>
    </Fragment>
  );
}

export default withTranslation('common')(App); 